import { makeStyles } from 'tss-react/mui';

const THUMBNAIL_WIDTH = 36;

export const useRachelProductRowStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.75, 1, 0.75, 0.75),
    borderRadius: theme.shape.borderRadiusXl,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      backgroundColor: theme.palette.custom.layout.shell.buttonHover,
    },
  },
  product: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    gap: theme.spacing(1),
  },
  thumbnail: {
    flexShrink: 0,
    width: THUMBNAIL_WIDTH,
  },
  thumbnailMedia: {
    '&, & img': {
      borderRadius: theme.shape.borderRadiusMd,
    },
  },
  texts: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: theme.spacing(0.25),
  },
  colors: {
    position: 'relative',
    zIndex: 1,
    alignSelf: 'flex-start',
  },
  price: {
    flexShrink: 0,
  },
}));
